import api from '../../api'
import shuffle from 'shuffle-array'

const state = {
  questions: [],
  animals: [],
  hideAndSeek: [],
  facts: [],
  avatars: [],
  avatarShoes: [],
  factFilesList: [],
  factCardsList: [],
  lastGameScore: 0,
  isNextLevel: false
}

const loadImage = (src) => {
  const img = new Image()
  img.src = src
}

const getters = {
  questions (state) {
    return state.questions
  },
  animals (state) {
    return state.animals
  },
  hideAndSeek (state) {
    return state.hideAndSeek
  },
  facts (state) {
    return state.facts
  },
  avatars (state) {
    return state.avatars
  },
  avatarShoes (state) {
    return state.avatarShoes
  },
  factFilesList (state) {
    return state.factFilesList
  },
  factCardsList (state) {
    return state.factCardsList
  },
  lastGameScore (state) {
    return state.lastGameScore
  },
  isNextLevel (state) {
    return state.isNextLevel
  }
}

const actions = {
  loadQuestions ({ commit }) {
    return api.getQuestions().then(data => {
      commit('setQuestions', data)
      if (Array.isArray(data)) {
        data.map(item => {
          if (item.hasOwnProperty('meta')) {
            loadImage(item.meta.background)
          }
        })
      }
    })
  },
  loadAnimals ({ commit }) {
    return api.getAnimals().then(data => {
      commit('setAnimals', data)
    })
  },
  loadHideAndSeek ({ commit }) {
    return api.getHideAndSeek().then(data => {
      commit('setHideAndSeek', data)
      if (Array.isArray(data)) {
        data.map(item => {
          if (item.hasOwnProperty('meta')) {
            loadImage(item.meta.seek_image)
            loadImage(item.meta.found_image)
          }
        })
      }
    })
  },
  loadFacts ({ commit }) {
    return api.getFacts().then(data => {
      commit('setFacts', data)
    })
  },
  loadCards ({ commit }) {
    return Promise.all([api.getFactFiles(), api.getFactCards()]).then(data => {
      commit('setFactFilesList', data[0])
      commit('setFactCardsList', data[1])
    })
  },
  loadAvatars ({ commit }) {
    return Promise.all([api.getAvatars(), api.getAvatarShoes()]).then(data => {
      commit('setAvatars', shuffle(data[0]))
      commit('setAvatarShoes', shuffle(data[1]))
    })
  }
}

const mutations = {
  setQuestions (state, data) {
    state.questions = data
  },
  setAnimals (state, data) {
    state.animals = data
  },
  setHideAndSeek (state, data) {
    state.hideAndSeek = data
  },
  setFactFilesList (state, data) {
    state.factFilesList = data
  },
  setFactCardsList (state, data) {
    state.factCardsList = data
  },
  setFacts (state, data) {
    state.facts = data
  },
  setAvatars (state, data) {
    state.avatars = data
  },
  setAvatarShoes (state, data) {
    state.avatarShoes = data
  },
  setLastGameScore (state, data) {
    state.lastGameScore = data
  },
  toggleIsNextLevel (state) {
    state.isNextLevel = !state.isNextLevel
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
